import React, { useState, useEffect } from 'react';
import {
  IconAngleArrowLeft,
  IconAngleArrowRight,
  IconCalendar,
  IconCaretDown,
} from '../../../common/icons';
import DispatcherTabs from '../common-elements/dispatcherTabs';
import Pagination from '../../../common/pagination';
import StaticTableContent from '../StaticTableContent';
import DoubleMovesCard from './elements/doublemovesCard';
import { IconColumn, IconFilter } from '../../../common/icons';

const cardItems = [
  {
    id: 1,
    count: 8,
    title: 'WBCT',
  },
  {
    id: 2,
    count: 9,
    title: 'WBCT',
  },
  {
    id: 3,
    count: 11,
    title: 'WBCT',
  },
  {
    id: 4,
    count: 15,
    title: 'WBCT',
  },
  {
    id: 5,
    count: 16,
    title: 'WBCT',
  },
  {
    id: 6,
    count: 18,
    title: 'WBCT',
  },
];

const DoubleMoves = (props) => {
  const [CardActive, setCardActive] = useState(1);
  useEffect(() => {
    document.body.className = 'has-subheader';
    return () => {
      document.body.className = '';
    };
  });

  return (
    <React.Fragment>
      <div className="position-relative subheader-wrapper">
        <DispatcherTabs activeTab={3} />
        <div className="page-fluid">
          <div className="top-page">
            <div className="top-page">
              <div className="pb-15 d-flex align-items-center">
                <div className="d-flex align-items-center">
                  <button className="btn btn-white mr-3">
                    <IconAngleArrowLeft />
                  </button>
                  <div className="d-flex align-items-center mr-3">
                    <h4 className="font-20 mb-0">Today</h4>
                    <IconCaretDown />
                  </div>
                  <button className="btn btn-white mr-3">
                    <IconAngleArrowRight />
                  </button>
                  <button className="btn btn-white">
                    <IconCalendar />
                  </button>
                </div>
                <Pagination className="ml-auto" />
              </div>
              {/* Cards Row */}
              <div
                className={`form-row mb-15 ${CardActive ? 'hasactive' : ''}`}
              >
                {cardItems.map(({ id, title, count }) => (
                  <DoubleMovesCard
                    title={title}
                    count={count}
                    onCardClicked={() => setCardActive(id)}
                    isCardActive={CardActive === id}
                  />
                ))}
              </div>
              {/* Double Moves Double Table */}
              <div className="form-row">
                <div className="col-md-6">
                  {/* Filter Row */}
                  <React.Fragment>
                    <div className="filter-row d-flex align-items-center">
                      <div className="font-14 font-weight-500 mr-20">
                        Returns
                      </div>
                      <div className="app-search header-search">
                        <span className="search-icon"> </span>
                        <div className="position-relative">
                          <input
                            type="search"
                            className="form-control input-search-left"
                            placeholder="Search..."
                            value=""
                          />
                        </div>
                      </div>
                      <div className="ml-auto d-flex">
                        <Pagination className="mr-10 pagination--bordered" />
                        <button className="btn btn-outline-light mr-2">
                          <IconFilter className="mr-2" />
                          Filter
                        </button>
                        <div className="position-relative">
                          <button className="btn btn-outline-light position-relative">
                            <IconColumn />
                          </button>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                  <div
                    className="table-responsive"
                    style={{ height: 'calc(100vh - 342px)' }}
                  >
                    <StaticTableContent />
                  </div>
                </div>
                <div className="col-md-6">
                  {/* Filter Row */}
                  <React.Fragment>
                    <div className="filter-row d-flex align-items-center">
                      <div className="font-14 font-weight-500 mr-20">Pulls</div>
                      <div className="app-search header-search">
                        <span className="search-icon"> </span>
                        <div className="position-relative">
                          <input
                            type="search"
                            className="form-control input-search-left"
                            placeholder="Search..."
                            value=""
                          />
                        </div>
                      </div>
                      <div className="ml-auto d-flex">
                        <Pagination className="mr-10 pagination--bordered" />
                        <button className="btn btn-outline-light mr-2">
                          <IconFilter className="mr-2" />
                          Filter
                        </button>
                        <div className="position-relative">
                          <button className="btn btn-outline-light position-relative">
                            <IconColumn />
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* Filter Popup */}
                  </React.Fragment>
                  <div
                    className="table-responsive"
                    style={{ height: 'calc(100vh - 342px)' }}
                  >
                    <StaticTableContent />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DoubleMoves;
